import ButtonLoader from "../items/buttonLoader";
const LogoutButton = ({ loading, setShowLogoutPopUp }) => {
  return (
    <>
      <div
        className="cursor-pointer mr-5  mr-5 d-flex gap-1"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setShowLogoutPopUp(true);
        }}
      >
        {loading ? (
          <>
            <ButtonLoader />
          </>
        ) : (
          <>
            <i className="icofont-logout fs-5 d-block text-danger" />
            <small className="text-white">خروج</small>
          </>
        )}
      </div>
    </>
  );
};

export default LogoutButton;
